import { useState, lazy, Suspense } from "react";
import PropTypes from "prop-types";
import { castArray, map, compact } from "lodash";

import styles from "./showFields.module.css";

const ImagesGalleryPage = lazy(
  () => import("../../../../components/shared/ImagesGalleryPage"),
);

export const defaultImageUrl = (id, size) =>
  `/api/storage/images/${id}/get/${size}`;

function Image({ value }) {
  const [galleryState, setGalleryState] = useState({
    isOpen: false,
    selectedImageId: null,
  });

  const images = compact(castArray(value));

  const handleImageClick = (imageId) => {
    setGalleryState({
      isOpen: true,
      selectedImageId: imageId,
    });
  };

  const handleCloseGallery = () => {
    setGalleryState({
      isOpen: false,
      selectedImageId: null,
    });
  };

  // Transform images for ImagesGalleryPage format
  const galleryImages = images.map(({ id }) => ({ id }));

  return (
    <div className={styles.Image}>
      {map(images, ({ id, name, thumbnailUrl }) => (
        <a
          key={id}
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleImageClick(id);
          }}
        >
          <img
            src={thumbnailUrl || defaultImageUrl(id, "200x200")}
            alt={name}
          />
        </a>
      ))}

      {galleryState.isOpen && (
        <Suspense fallback={null}>
          <ImagesGalleryPage
            images={galleryImages}
            imageId={galleryState.selectedImageId}
            onClose={handleCloseGallery}
          />
        </Suspense>
      )}
    </div>
  );
}
const imageShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  imageUrl: PropTypes.string, // for storybook
  thumbnailUrl: PropTypes.string, // for storybook
});
Image.propTypes = {
  value: PropTypes.oneOfType([PropTypes.arrayOf(imageShape), imageShape]),
};

export default Image;
